import { useEffect, useState } from "react"
import { Progress, Skeleton } from "@mantine/core"
import { IconStar } from "../common/icon"
import { HeaderBack } from '@/components/common/header';
import _ from "lodash";
import { _getUserReview, _convertRatingAverage, _convertRatingAveragePercentage } from "../../libraries/common";
import { hasCookie, getCookie } from "cookies-next";
import { useRouter } from "next/router";
import { LoginModal } from "../modal";
import { EmptyData } from "../common/emptyData";
import { SkeletonCategory, SkeletonNewsItem, SkeletonParagraph } from "../common/skeleton";
import { ProfilePicture } from "../common/image";
import { Footer } from "../common/footer";
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";
import { MyBody } from "../body/body";

const categoryList = [
    {label: "All", value: 0},
    {label: "5 Star", value: 5},
    {label: "4 Star", value: 4},
    {label: "3 Star", value: 3},
    {label: "2 Star", value: 2},
    {label: "1 Star", value: 1},
]

const UserReviewDetail = (props) => {
    const {userReviewList, t, loading = false, fetchedData = {}, setOpened, isLogin = {}, router } = props

    const [ratingDropdown, setRatingDropdown] = useState(false)
    const [seletedCategory, setSelectedCategory] = useState(0)
    if(loading == true){
        return (
            <div className="vehicleUserReview">
                <div className="vehicleUserReview_title containerPadding">
                    <p className="fontSize_16 fontWeight_bold">
                        {`${fetchedData?.name} ${t('user_review')}`} 
                    </p>
                </div>
                <div className="vehicleUserReview_container">
                    <div className="vehicleUserReview_top containerPadding">
                        <div className="vehicleUserReview_row2">
                            <div className="vehicleUserReview_row2_rating">
                                <div className="vehicleUserReview_row2_rating_num" style={{width: '5rem'}} >
                                    <SkeletonParagraph row={1} isTitle />
                                </div>
                                <div className="vehicleUserReview_row2_rating_star_iconList positionRelative" style={{width: '10rem', height: '1.5rem'}} >
                                    <div className="absoluteSkeletonBox">
                                        <Skeleton height={'100%'} radius={'5rem'} />
                                    </div>
                                </div>
                                <div onClick={()=>{setRatingDropdown(!ratingDropdown)}} className="vehicleUserReview_row2_rating_dropdown_icon">
                                    {/* TODOS icon color */}
                                    {
                                        ratingDropdown == false ?
                                        <img 
                                            src="/assets/images/expand_more.svg"
                                        />
                                        :
                                        <img 
                                            src="/assets/images/expand_up_icon.svg"
                                        />
                                    }
                                </div>
                            </div>
                            <div className="" style={{width: '10rem'}}>
                                <div className="fontSize_12 fontColor_grey2">
                                    <SkeletonParagraph row={1} />
                                </div>
                            </div>
                        </div>
                        {
                            ratingDropdown == true &&
                            <div className="vehicleUserReview_row3">
                                <div className="vehicleUserReview_row3_left">
                                    {
                                        _.reduce([5,4,3,2,1], (result, value, key)=>{
                                            result.push(
                                                <div key={key} className="vehicleUserReview_row3_left_row">
                                                    <p className="fontSize_14 fontColor_grey2">
                                                        {value}
                                                    </p>
                                                    <SkeletonParagraph row={1} />
                                                </div>
                                            )
                                            return result
                                        },[])
                                    }
                                </div>
                            </div>
                        }
                        <div className="vehicleUserReview_row1">
                            <p className="fontSize_16 fontWeight_medium fontColor_lightGrey3">
                                {t('ratings_reviews')}
                            </p>
                            <div className="fontSize_12 fontColor_grey2" style={{width: '10rem'}}>
                                <SkeletonParagraph row={1} />
                            </div>
                        </div>
                        <div className="vehicleReviewPage_button primaryButtonBackground">
                            <p className="fontSize_16 fontWeight_bold fontColor_white">
                                {t('write_a_review')}
                            </p>
                        </div>
                    </div>
                    <div className="vehicleReviewPage_category_list">
                        <div className="vehicleReviewPage_category_wrap containerPadding">
                            <SkeletonCategory />
                        </div>
                    </div>
                    <div className="vehicleUserReview_commandList containerPadding">
                        {
                            _.times(3, (key)=>(
                                <div key={key} className="vehicleUserReview_commandItem">
                                    <div className="vehicleUserReview_commandItem_header">
                                        <div className="vehicleReviewPage_commandItem_header_profileImageOuter">
                                            <div className="absoluteSkeletonBox">
                                                <Skeleton height={'100%'} radius={'50%'}/>
                                            </div>
                                        </div>
                                        <div style={{width: '10rem'}}>
                                            <div className="fontSize_12 fontWeight_semiBold" style={{width: '10rem'}}>
                                                <SkeletonParagraph row={1} />
                                            </div>
                                            <div className="vehicleUserReview_commandItem_ratingList positionRelative">
                                                <SkeletonParagraph row={1} />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="vehicleUserReview_commandItem_description">
                                        <div className="fontSize_12">
                                            <SkeletonParagraph row={3} />
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className="vehicleUserReview">
            <div className="vehicleUserReview_title containerPadding">
                <p className="fontSize_16 fontWeight_bold">
                    {`${fetchedData?.name} ${t('user_review')}`} 
                </p>
            </div>
            <div className="vehicleUserReview_container">
                <div className="vehicleUserReview_top containerPadding">
                    <div className="vehicleUserReview_row2">
                        <div className="vehicleUserReview_row2_rating">
                            <div className="vehicleUserReview_row2_rating_num">
                                <p className="fontSize_25 fontWeight_bold">
                                    {_convertRatingAverage(userReviewList?.total_rating ?? 0, userReviewList?.total_review ?? 0)}
                                </p>
                                <p className="fontSize_10 vehicleUserReview_row2_rating_num_text">
                                    / 5
                                </p>
                            </div>
                            <div className="vehicleUserReview_row2_rating_star_iconList">
                                {
                                    _.reduce([1,2,3,4,5],(result, value, key)=>{
                                        result.push(
                                            <div key={key} className="vehicleUserReview_row2_rating_star_icon">
                                                <IconStar color={_convertRatingAverage(userReviewList?.total_rating ?? 0, userReviewList?.total_review ?? 0) >= value ? "#FFC327" : undefined} />
                                            </div>
                                        )
                                        return result
                                    },[])
                                }
                            </div>
                            <div onClick={()=>{setRatingDropdown(!ratingDropdown)}} className="vehicleUserReview_row2_rating_dropdown_icon cursorPointer">
                                {/* TODOS icon color */}
                                {
                                    ratingDropdown == false ?
                                    <img 
                                        src="/assets/images/expand_more.svg"
                                    />
                                    :
                                    <img 
                                        src="/assets/images/expand_up_icon.svg"
                                    />
                                }
                            </div>
                        </div>
                        <div className="">
                            <p className="fontSize_12 fontColor_grey2">
                                {userReviewList?.total_rating} Rating
                            </p>
                        </div>
                    </div>
                    {
                        ratingDropdown == true &&
                        <div className="vehicleUserReview_row3">
                            <div className="vehicleUserReview_row3_left">
                                {
                                    _.reduce([5,4,3,2,1], (result, value, key)=>{
                                        result.push(
                                            <div key={key} className="vehicleUserReview_row3_left_row">
                                                <p className="fontSize_14 fontColor_grey2">
                                                    {value}
                                                </p>
                                                <div className="vehicleUserReview_row3_left_progress">
                                                    <Progress value={userReviewList?.total_review > 0 ? ((userReviewList?.group_rating?.[value]?.length / userReviewList?.total_review) * 100).toFixed(0) : 0} color={"#FFC327"} />
                                                </div>
                                            </div>
                                        )
                                        return result
                                    },[])
                                }
                            </div>
                            <div className="vehicleUserReview_row3_right">
                                <p className="fontSize_24 fontColor_grey2">
                                    {`${_convertRatingAveragePercentage(userReviewList?.total_rating ?? 0, userReviewList?.total_review ?? 0)}%`}
                                </p>
                                <p className="fontSize_12 fontColor_grey2">
                                    {t('recommended')}
                                </p>
                            </div>
                        </div>
                    }
                    <div className="vehicleUserReview_row1">
                        <p className="fontSize_16 fontWeight_medium fontColor_lightGrey3">
                            {t('ratings_reviews')}
                        </p>
                        <p className="fontSize_12 fontColor_grey2">
                            {`${userReviewList?.total_review} ${t("review")}`}
                        </p>
                    </div>
                    <div onClick={()=>{isLogin == true ? router.push(router.query.vehicle[0] + "/" + router.query.vehicle[1] + "/write-review") : setOpened(true) }} className="vehicleReviewPage_button primaryButtonBackground cursorPointer">
                        <p className="fontSize_16 fontWeight_bold fontColor_white">
                            {t('write_a_review')}
                        </p>
                    </div>
                </div>
                <div className="vehicleReviewPage_category_list">
                    <div className="vehicleReviewPage_category_wrap containerPadding">
                        {
                            _.reduce(categoryList, (result, value, key)=>{
                                result.push(
                                    <div onClick={()=>{setSelectedCategory(value.value)}} key={key} className={`vehicleReviewPage_category_button cursorPointer ${seletedCategory == value.value && "vehicleReviewPage_category_button_active"}`}>
                                        <p className={`fontSize_14 ${seletedCategory == value.value && "fontWeight_bold"}`}>
                                            {value.label}
                                        </p>
                                    </div> 
                                )
                                return result
                            },[])
                        }
                        
                    </div>
                </div>
                <div className="vehicleUserReview_commandList containerPadding">
                    {
                        ((_.isEmpty(userReviewList?.data) || (_.isEmpty(userReviewList?.group_rating?.[seletedCategory]) && seletedCategory != 0))) ?
                        <>
                            <EmptyData t={t} />
                        </>
                        :
                        <>
                            {
                                _.reduce(seletedCategory == 0 ? userReviewList?.data : userReviewList?.group_rating?.[seletedCategory], (result, value, key)=>{
                                    result.push(
                                        <div key={key} className="vehicleUserReview_commandItem">
                                            <div className="vehicleUserReview_commandItem_header">
                                                <div className="vehicleReviewPage_commandItem_header_profileImageOuter">
                                                    <ProfilePicture 
                                                        size={4.6}
                                                        imagePath={!_.isEmpty(value.profile_image) ? process.env.NEXT_PUBLIC_FS_URL + value.profile_image : undefined}
                                                    />
                                                </div>
                                                <div>
                                                    <p className="fontSize_12 fontWeight_semiBold">
                                                        {value.full_name}
                                                    </p>
                                                    <div className="vehicleUserReview_commandItem_ratingList">
                                                        {
                                                            _.reduce([1,2,3,4,5],(result2, value2, key2)=>{
                                                                result2.push(
                                                                    <div key={`${key}-${key2}`} className="vehicleUserReview_commandItem_ratingIcon">
                                                                        <IconStar  color={value2 <= value.rating ? "#FFC327" : undefined} />
                                                                    </div>
                                                                )
                                                                return result2
                                                            },[])
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="vehicleUserReview_commandItem_description">
                                                <p className="fontSize_12">
                                                    {value.review}
                                                </p>
                                            </div>
                                        </div>
                                    )
                                    return result
                                },[])
                            }
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

// arrage Code
export const VehicleReview = (props) => {
    const { t, device, session, params, fetchedData } = props
    const [loading, setLoading] = useState(true)

    // user review list
    const [userReviewList, setUserReviewList] = useState([]);

    const router = useRouter()
    // TODOS arrange code
    let userCookies;
    let isLogin;

    userCookies = getCookie("user") && JSON.parse(getCookie("user"));
    isLogin = !_.isEmpty(userCookies) ? true : false;

    // login 
    const [opened, setOpened] = useState(false)

    useEffect(()=>{
        const fetchData = async()=>{
            await _getUserReview(setUserReviewList, {brand_custom_url: fetchedData?.brand_custom_url,model_custom_url: fetchedData?.model_custom_url})
            setLoading(false)
        }
        fetchData()
    },[])

    return (
        <>
            <AllMeta
                title={t('vehicleBrandModelReviewPage_meta_title', { brandModel: fetchedData?.name })}
                description={t('vehicleBrandModelReviewPage_meta_description', { brand: fetchedData?.brand_name,  brandModel: fetchedData?.name })}
                keyword={t('vehicleBrandModelReviewPage_meta_keyword', { brandModel: fetchedData?.name})}
                image={!_.isEmpty(fetchedData?.cover_image_path) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.cover_image_path}` : undefined}
                imageWidth={1275}
                imageheight={666}
            />
            <Head><title>{t('vehicleBrandModelReviewPage_title', {brandModel: fetchedData?.name})}</title></Head>
            <MyBody
                t={t}
                headerComponent={
                    <HeaderBack t={t} />
                }
                modalComponent={
                    <LoginModal 
                        opened={opened}
                        setOpened={setOpened}
                        t={t}
                        isWriteReview={true}
                    />
                }
            >
                <div className="vehicleReviewPage">
                    <UserReviewDetail 
                        userReviewList={userReviewList}
                        t={t}
                        loading={loading}
                        fetchedData={fetchedData}
                        setOpened={setOpened}
                        isLogin={isLogin}
                        router={router}
                    />
                </div>
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         <AllMeta
    //             title={t('vehicleBrandModelReviewPage_meta_title', { brandModel: fetchedData?.name })}
    //             description={t('vehicleBrandModelReviewPage_meta_description', { brand: fetchedData?.brand_name,  brandModel: fetchedData?.name })}
    //             keyword={t('vehicleBrandModelReviewPage_meta_keyword', { brandModel: fetchedData?.name})}
    //             image={!_.isEmpty(fetchedData?.cover_image_path) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.cover_image_path}` : undefined}
    //             imageWidth={1275}
    //             imageheight={666}
    //         />
    //         <Head><title>{t('vehicleBrandModelReviewPage_title', {brandModel: fetchedData?.name})}</title></Head>
    //         <div className='bodyContainer'>
    //             <div className='contentContainer'>
    //                 <div className="vehicleReviewPage">
    //                     <HeaderBack t={t} />
    //                     <UserReviewDetail 
    //                         userReviewList={userReviewList}
    //                         t={t}
    //                         loading={loading}
    //                         fetchedData={fetchedData}
    //                         setOpened={setOpened}
    //                         isLogin={isLogin}
    //                         router={router}
    //                     />
    //                 </div>
    //                 <Footer t={t} />
    //             </div>
    //         </div>
    //         <LoginModal 
    //             opened={opened}
    //             setOpened={setOpened}
    //             t={t}
    //             isWriteReview={true}
    //         />
    //     </>
    // )
}